import { MAX_ROOM_MEMBERS_COUNT } from "containers/BreakoutRooms/constants";

export const getAllowedRoomMembersCount = (
  isAdmin: boolean,
  roomIsOccupiedByAdmin: boolean,
  maxRoomMembers: number = MAX_ROOM_MEMBERS_COUNT,
) => (isAdmin ? maxRoomMembers + 1 : roomIsOccupiedByAdmin ? maxRoomMembers + 1 : maxRoomMembers);
